import { useMemo } from "react";

import clsx from "clsx";

import { TransfersGrid } from "features/transfers";

export const CampaignTransfers = ({ campaign_id, className, ...props }) => {
  const classes = clsx("campaign-transfers", className);
  const filterParams = useMemo(() => {
    return {
      campaign_id,
    };
  }, [campaign_id]);
  return (
    <TransfersGrid
      filterParams={filterParams}
      className={classes}
      gridId="campaign-transfers"
    />
  );
};
